import store from "@/store";
import { InspectKbn, SeibiKbn } from "@/model/InspectKbn";
import { InspectStaff } from "@/model/InspectStaff";
import { LiftUse } from "@/model/LiftUse";
import { InspectDetail } from "@/model/InspectDetail";
import { InspectionDetailState } from "@/store/modules/inspectionDetailStore";

const namespace = "InspectionDetail";

export class InspectionStaffSeibishiDetailStoreService {
  deSelSeibishi: boolean = false;

  // サービス初期化時に整備士の選択管理枠をStoreへ登録する
  constructor() {
    this.addNowSelected();
  }

  // InspectionDetail Store全体の現在状態を参照する
  get currentState(): InspectionDetailState {
    return store.getters[`${namespace}/currentState`];
  }

  // 整備士が選択済みかどうかを参照する
  get nowSelected(): boolean {
    const nowSelected = store.getters[`${namespace}/getNowSelected`];
    if (nowSelected.staffSeibishi === true || nowSelected.staffSeibishi === false) {
      return nowSelected.staffSeibishi;
    }
    this.addNowSelected();
    return false;
  }

  // 補助整備士一覧の選択済みデータを参照する
  get staffHojo(): InspectStaff[] {
    return store.getters[`${namespace}/getStaffHojo`];
  }

  // 整備士一覧の選択済みデータを参照する
  get staffSeibishi(): InspectStaff[] {
    return store.getters[`${namespace}/getStaffSeibishi`];
  }

  // 整備士と補助整備士の合計選択上限値を参照する
  get maxSeibishiHojoStaffCount(): number {
    return store.getters[`${namespace}/effectiveMaxSeibishiHojoStaffCount`];
  }

  // 整備士の選択管理枠をStoreへ追加する
  addNowSelected() {
    return store.dispatch(`${namespace}/addNowSelected`, "staffSeibishi");
  }

  // 整備士の選択済み状態をStoreへ反映する
  setNowSelected(payload: boolean) {
    return store.dispatch(`${namespace}/setNowSelected`, {
      key: "staffSeibishi",
      value: payload
    });
  }

  // 整備士の選択状態からスタート可否判定用の状態を更新する
  checkDisableStart(arrData: any, isUnSelect?: boolean) {
    let checked: boolean = false;
    if (isUnSelect) {
      checked = true;
    } else if (arrData) {
      checked = arrData.some((data: any) => data.selected == "1");
    }
    this.setNowSelected(checked);
  }

  // 整備士一覧をStoreへ反映する
  setStaffSeibishi(payload: InspectStaff[]) {
    return store.dispatch(`${namespace}/setStaffSeibishi`, payload);
  }

  // 共通処理から扱う整備士一覧を返す
  get list(): InspectStaff[] {
    return this.currentState.staffSeibishi;
  }

  // スタート時に保存対象にする整備士一覧を返す
  get selectedList(): InspectStaff[] {
    return this.staffSeibishi;
  }

  // 共通処理から整備士一覧をStoreへ反映する
  setList(payload: InspectStaff[]) {
    return this.setStaffSeibishi(payload);
  }

  // テンプレート表示用の整備士選択肢リストを生成する
  getTargetList() {
    return this.list.map((data: any) => {
      return {
        "mode": 1,
        "btnDel": false,
        "btnSel": data.selected == '1',
        "btnFre": data.selected == '0',
        "btnUse": data.inProgress == '1',
        "key": data.staffCd,
        "dataSet": data.staffCd,
        "isDisabled": false,
        "icon": "icon-engineer",
        "label": data.staffNm,
        "labelEntends1": null,
        "labelEntends2": null,
        "labelEntends3": null,
      };
    });
  }

  // スタート時に選択中の整備士を保存データへ反映する
  setStartInspectDetail(inspectionDetail: InspectDetail) {
    inspectionDetail.seibishi = [];
    this.selectedList.filter((data: InspectStaff) => {
      if (data.selected == "1") {
        inspectionDetail.seibishi.push({
          staffCd: data.staffCd,
          staffNm: data.staffNm
        });
      }
    });
  }

  // 取得済みの検査構成から整備士の初期選択情報を反映する
  applyInitialInspectionDetail(data: any, inspectionDetail?: InspectDetail) {
    // ダミー
    return { data, inspectionDetail };
  }

  // 整備士追加時に整備士・補助整備士の合計上限を超えないか判定する
  checkValidCountSeibishiHojo() {
    const hojo = this.staffHojo.filter(data => data.selected == "1").length;
    return hojo < this.maxSeibishiHojoStaffCount;
  }

  // 整備士の選択クリックを処理する
  select(code: string, confirm: boolean = false) {
    const staffSeibishi = this.list;
    let inprogressStaff: InspectStaff | null = null;
    staffSeibishi.map(data => {
      if (data.staffCd == code) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          if (this.checkValidCountSeibishiHojo()) {
            if (data.inProgress == 1 && !confirm) {
              inprogressStaff = data;
            }
            staffSeibishi.map(data3 => (data3.selected = "0"));
            this.deSelSeibishi = false;
            data.selected = "1";
          }
        }
      }
    });
    this.setList([...staffSeibishi]);
    this.checkDisableStart(staffSeibishi, this.deSelSeibishi);
    return { deSelSeibishi: this.deSelSeibishi, inprogressStaff };
  }

  // 整備士の「選択無し」状態を切り替える
  deSelect() {
    const staffSeibishi = this.list;
    if (!this.deSelSeibishi) {
      staffSeibishi.map(data => (data.selected = "0"));
    }
    this.deSelSeibishi = !this.deSelSeibishi;
    this.setList([...staffSeibishi]);
    this.checkDisableStart(staffSeibishi, this.deSelSeibishi);
    return this.deSelSeibishi;
  }

  // 整備士で「選択無し」を表示できるか返す
  canDeSelect() {
    return true;
  }

  // 整備士が「選択無し」状態か返す
  isDeSelected() {
    return this.deSelSeibishi;
  }

  // 共通呼び出し用の「選択無し」クリック処理
  clickDeSelect() {
    return this.deSelect();
  }

  // Storeに既存リストがある場合に選択状態を再評価する
  applyExistingList() {
    const staffSeibishi = this.list;
    if (this.selectedList.length == 0) {
      this.deSelSeibishi = true;
    }
    this.checkDisableStart(staffSeibishi, this.deSelSeibishi);
    return {
      staffSeibishi,
      deSelSeibishi: this.deSelSeibishi
    };
  }

  // API取得結果から整備士一覧の初期選択状態を作成する
  setInitialList(res: InspectStaff[], selectedStaff: any[] | undefined, isDeSelStaff: boolean) {
    const staffSeibishi = res.map(data => {
      let selected = "0";
      if (selectedStaff) {
        if (selectedStaff.findIndex(seibishi => data.staffCd == seibishi.staffCd) > -1) {
          selected = "1";
          this.setNowSelected(true);
        }
      }
      return { ...data, selected };
    });
    this.deSelSeibishi = false;
    if ((!selectedStaff || selectedStaff.length === 0) && isDeSelStaff) {
      this.setNowSelected(true);
      this.deSelSeibishi = true;
    }
    this.setList(staffSeibishi);
    return {
      staffSeibishi,
      deSelSeibishi: this.deSelSeibishi
    };
  }

  // 整備士一覧を既存StoreまたはAPIから取得する
  getDataList(
    loadInitialList: () => Promise<InspectStaff[]>,
    selectedStaff: any[] | undefined,
    isDeSelStaff: boolean
  ) {
    if (this.list.length > 0) {
      this.applyExistingList();
      return {
        hasExistingList: true,
        promise: null
      };
    }
    return {
      hasExistingList: false,
      promise: loadInitialList().then((res: InspectStaff[]) => {
        return this.setInitialList(res, selectedStaff, isDeSelStaff);
      })
    };
  }
}
